import { Box, CircularProgress, Typography } from '@mui/material'

const DocumentLoader = ({
  text = 'Loading...',
  thickness = 5,
  size = 35,
  mt = 8,
  showText = true
}) => {
  return (
    <Box display="flex" justifyContent="center" mt={mt}>
      <Box textAlign="center">
        <CircularProgress
          sx={{ color: '#777' }}
          thickness={thickness}
          size={size}
        />
        {showText && (
          <Typography variant="body2" mt={1} fontSize={12}>
            {text}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default DocumentLoader
